import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    chartData: Object,
    title: String,
    totalEvents: Number
  };

  connect() {
    this.initChart();
  }

  initChart() {
    if (this.totalEventsValue === 0) {
      return;
    }

    const canvas = this.element.querySelector('canvas');
    if (!canvas || !window.Chart) {
      return;
    }
    
    const ctx = canvas.getContext('2d');
    
    const labels = Object.keys(this.chartDataValue);
    const data = Object.values(this.chartDataValue);
    const colors = labels.map(eventType => this.getColorForEventType(eventType));
    
    new window.Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: labels,
        datasets: [{
          data: data,
          backgroundColor: colors,
          borderWidth: 2,
          borderColor: '#fff'
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                const percentage = ((context.parsed / this.totalEventsValue) * 100).toFixed(1);
                return context.label + ': ' + context.parsed + ' (' + percentage + '%)';
              }
            }
          }
        },
        cutout: '60%'
      }
    });
  }

  getColorForEventType(eventType) {
    const colorMap = {
      'Ok': '#198754',        // success
      'Bad': '#dc3545',       // danger  
      'Warning': '#ffc107',   // warning
      'Info': '#0dcaf0'       // info
    };
    return colorMap[eventType] || '#6c757d';
  }
}